var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".PricingCheck"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_0_131",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7C0 3.13401 3.13401 0 7 0V0C10.866 0 14 3.13401 14 7V7C14 10.866 10.866 14 7 14V14C3.13401 14 0 10.866 0 7V7Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 7M14 7M14 7M0 7M7 0M14 7M7 14M0 7M7 14V13.375C3.47918 13.375 0.625 10.5208 0.625 7H0H-0.625C-0.625 11.2112 2.78883 14.625 7 14.625V14ZM14 7H13.375C13.375 10.5208 10.5208 13.375 7 13.375V14V14.625C11.2112 14.625 14.625 11.2112 14.625 7H14ZM7 0V0.625C10.5208 0.625 13.375 3.47918 13.375 7H14H14.625C14.625 2.78883 11.2112 -0.625 7 -0.625V0ZM7 0V-0.625C2.78883 -0.625 -0.625 2.78883 -0.625 7H0H0.625C0.625 3.47918 3.47918 0.625 7 0.625V0Z",
    fill: "url(#paint0_linear_0_131)",
    mask: "url(#path-1-inside-1_0_131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69252 4.22918C9.96962 3.94499 10.4438 3.92195 10.7517 4.17773C11.0596 4.4335 11.0846 4.87124 10.8075 5.15544L6.30747 9.77082C6.02001 10.0656 5.52351 10.0777 5.21967 9.79723L3.21967 7.95107C2.92678 7.68071 2.92678 7.24237 3.21967 6.97201C3.51256 6.70164 3.98744 6.70164 4.28033 6.97201L5.72135 8.30218L9.69252 4.22918Z",
    fill: "#0D70DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_131",
    x1: 7,
    y1: 0,
    x2: 7,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBD0E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSmall);
export default __webpack_public_path__ + "static/media/check-small.86aba7c29941e4b4a0ce7a6bc1fbded5.svg";
export { ForwardRef as ReactComponent };